import React, { useEffect, useState } from 'react';
import xlsx from 'node-xlsx';
import { saveAs } from 'file-saver';
import { useTranslation } from "react-i18next";
import { FileDownload } from "@mui/icons-material";

/**
 * Composant qui permet de download un ficher excel
 * @param {array} data - données à envoyer dans le fichier excel
 * @param {array} name - nom du fichier excel
 * @param {array} formattedHeader - nom des colonnes du fichier excel
 */

export default function FileSaverExcel({ data, name, formattedHeader }) {
    const { t } = useTranslation();
    const [formattedFileName, setFormattedFileName] = useState('');

    // Formater le nom du fichier lorsque le composant est monté ou lorsque le nom change
    useEffect(() => {
        setFormattedFileName(formatFileName(name));
    }, [name]);

    //Paramètre du fichier excel
    const formatFileName = (fileName) => {
        const maxLength = 31; // Limite Excel pour le nom de la feuille
        const invalidChars = /[\\/*?[\]]/g; // Caractères interdits dans Excel
        let formattedName = fileName.replace(invalidChars, '-');
        if (formattedName.length > maxLength) {
            formattedName = `${formattedName.substring(0, maxLength - 3)}...`;
        }
        return formattedName; // Retourne le nom formaté
    };

    // Méthode pour télécharger le fichier Excel
    const handleConfirmImport = async () => {
        const blob = generateExcelData(data, formattedFileName, formattedHeader);
        saveAs(blob, `${formatFileName(name)}.xlsx`);
    };

    //Méthode pour formatter les données excel
    const generateExcelData = (devices, fileName, formattedHeader) => {
        //Avoir toute les données du tableau
        const combinedData = [];
        devices.forEach(device => {
            Object.values(device).forEach(callDetail => {
                combinedData.push(callDetail);
            });
        });

        const dataExcel = combinedData.map(callDetail => {
            const { source, ...rowData } = callDetail;
            return rowData;
        });

        if (dataExcel.length === 0) {
            const excelBuffer = xlsx.build([{ name: fileName, data: [] }]);
            return new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        }

        const firstDataRow = dataExcel.find(row => row && typeof row === 'object');
        const columnNames = Object.keys(firstDataRow).filter(col => !col.startsWith('__'));
        const excelData = [];

        if (!formattedHeader) {
            excelData.push(columnNames);
        }

        let previousGroupKey = null;

        dataExcel.forEach(device => {
            const currentGroupKey = device.__groupKey || null;

            if (currentGroupKey !== null && previousGroupKey !== currentGroupKey) {
                if (previousGroupKey !== null) {
                    excelData.push(new Array(columnNames.length).fill(""));
                }
            }

            if (previousGroupKey !== null && currentGroupKey === null && previousGroupKey !== currentGroupKey) {
                excelData.push(new Array(columnNames.length).fill(""));
            }

            const rowData = columnNames.map(col => {
                // Récupérer la valeur de la colonne ou la date si c'est une clé correspondante
                const dateKeys = ["starttime", "endtime", "releasetime", "answertime", "reporttime"];
                return dateKeys.includes(col) && device[col] ? device[col].date : device[col] || "";
            });

            excelData.push(rowData);
            previousGroupKey = currentGroupKey;
        });

        // Créer le contenu du fichier Excel
        const excelBuffer = xlsx.build([{ name: fileName, data: excelData }]);
        // Convertir le contenu en Blob
        return new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    };

    return (
        <div onClick={handleConfirmImport} className="saveCSVWebexCalling"><FileDownload /> {t("Save as Excel")}</div>
    );
}
